import e from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import v from "./iconfont.es5471.js";
const p = {
  display: "block"
}, x = ({ size: a = 16, useVw: l, useRem: o, color: n, withColor: i, removeClassName: t, disableSSR: d, style: c, ...h }) => {
  const m = c ? { ...p, ...c } : p;
  return /* @__PURE__ */ e.createElement(v, { disableSSR: d }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "32px-jigouhevipzhuye", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: l ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (o ? "rem" : "px"), height: l ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (o ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: m, fill: "none", ...h }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: t ? "" : "32px-æºæåvipä¸»é¡µ"
    },
    /* @__PURE__ */ e.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: i ? r(n, 0, "#262933") : "#262933",
        datafollowfill: i ? r(n, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M12.483 17.377a.9.9 0 0 0-1.185 1.355l2.756 2.412a2.955 2.955 0 0 0 3.891 0l2.757-2.412a.9.9 0 1 0-1.186-1.355L16.76 19.79c-.435.38-1.085.38-1.52 0l-2.757-2.412Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M15.542 4.439a.9.9 0 0 1 .916 0l11.3 6.677a.9.9 0 0 1-.458 1.675h-1.9v13.095h.873a.9.9 0 0 1 0 1.8H5.728a.9.9 0 1 1 0-1.8H6.6V12.791H4.7a.9.9 0 0 1-.458-1.675l11.3-6.677ZM8.4 12.79h15.2v13.095H8.4V12.791Zm15.608-1.8L16 6.259l-8.008 4.732h16.016Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, E = x;
export {
  E as default
};
